"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowButtonTextEditor_1 = require("../../../../../../../shared/components/editors/CardRowButtonTextEditor");
var CardRowTextEditor_1 = require("../../../../../../../shared/components/editors/CardRowTextEditor");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var BonusTPLLocaleMainEditor = /** @class */ (function (_super) {
    __extends(BonusTPLLocaleMainEditor, _super);
    function BonusTPLLocaleMainEditor(props) {
        return _super.call(this, props) || this;
    }
    BonusTPLLocaleMainEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_language_id: _item.app_language_id,
                    app_language_title: _item.app_language_title,
                    app_currency_id: _item.app_currency_id,
                    app_currency_title: _item.app_currency_title,
                    wager_pre_create_teaser_url: _item.wager_pre_create_teaser_img_url,
                    wager_title: _item.wager_title,
                    freespin_pre_create_teaser_url: _item.freespin_pre_create_teaser_img_url,
                    freespin_title: _item.freespin_title,
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Шаблоны локализаций бонуса", "Редактирование шаблона локализации"]);
                });
            }
        }
        else {
            this.setState({
                app_language_id: 0,
                app_language_title: "",
                app_currency_id: 0,
                app_currency_title: "",
                wager_pre_create_teaser_url: "",
                wager_title: "",
                freespin_pre_create_teaser_url: "",
                freespin_title: "",
                is_fullscreen: false
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Шаблоны локализаций бонуса", "Создание шаблона локализации"]);
            });
        }
        this.doReSetRules();
    };
    BonusTPLLocaleMainEditor.prototype.doReSetRules = function () {
        this.setState({
            app_language_rules: { isError: false },
            app_currency_rules: { isError: false },
            wager_pre_create_teaser_url_rules: { isError: false },
            wager_title_rules: { isError: false },
            freespin_pre_create_teaser_url_rules: { isError: false },
            freespin_title_rules: { isError: false },
        });
    };
    BonusTPLLocaleMainEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_language_id <= 0) || (this.state.app_language_title.length === 0)) {
            this.setState({
                app_language_rules: { isError: true, errorMessage: "Язык не выбран!" }
            });
            return false;
        }
        if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({
                app_currency_rules: { isError: true, errorMessage: "Валюта не выбрана!" }
            });
            return false;
        }
        if ((!this.state.wager_title) || (this.state.wager_title.length === 0)) {
            this.setState({
                wager_title_rules: { isError: true, errorMessage: "Название вейджера не заполнено!" }
            });
            return false;
        }
        if ((!this.state.wager_pre_create_teaser_url) || (this.state.wager_pre_create_teaser_url.length === 0)) {
            this.setState({
                wager_pre_create_teaser_url_rules: { isError: true, errorMessage: "Изображение тизера вейджера не выбрано!" }
            });
            return false;
        }
        return true;
    };
    BonusTPLLocaleMainEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                app_language_id: this.state.app_language_id,
                app_currency_id: this.state.app_currency_id,
                wager_title: this.state.wager_title,
                wager_pre_create_teaser_img_url: this.state.wager_pre_create_teaser_url,
                freespin_title: this.state.freespin_title,
                freespin_pre_create_teaser_img_url: this.state.freespin_pre_create_teaser_url,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Локализация шаблона бонуса изменена!");
            });
        }
    };
    BonusTPLLocaleMainEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_language_id: this.state.app_language_id,
                app_currency_id: this.state.app_currency_id,
                bonus_template_id: this.props.rootRecord.key,
                wager_title: this.state.wager_title,
                wager_pre_create_teaser_img_url: this.state.wager_pre_create_teaser_url,
                freespin_title: this.state.freespin_title,
                freespin_pre_create_teaser_img_url: this.state.freespin_pre_create_teaser_url,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Локализация шаблона бонуса добавлена!");
            });
        }
    };
    BonusTPLLocaleMainEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusTPLLocaleMainEditor.prototype.DoShowSelectWagerImageDialog = function () {
        var _this = this;
        this.props.dialogSelectImage.SetDialogTitle("Выбор изображения").SetOnSelect(function (brandIdentity, dirName, fileName) {
            _this.setState({ wager_pre_create_teaser_url: brandIdentity + "/" + dirName + "/" + fileName }, function () {
                _this.props.dialogSelectImage.Close();
            });
        }).Show();
    };
    BonusTPLLocaleMainEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новая локализация шаблона бонуса";
        }
        else {
            return "Изменить локализацию шаблона бонуса";
        }
    };
    BonusTPLLocaleMainEditor.prototype.getActionButtons = function () {
        var bTitle = { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" };
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: bTitle, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BonusTPLLocaleMainEditor.prototype.getMainEditContent = function () {
        var _this = this;
        return (React.createElement("div", { style: {
                minHeight: "500px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start"
            } },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык:", placeholder: "Выберите язык" }, value: { key: this.state.app_language_id, value: this.state.app_language_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_language_id: newVal.key,
                        app_language_title: newVal.value,
                        app_language_rules: { isError: false }
                    });
                }, items: this.props.availLanguages, required: true, rules: this.state.app_language_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта:", placeholder: "Выберите валюту" }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        app_currency_rules: { isError: false }
                    });
                }, items: this.props.availCurrencies, required: true, rules: this.state.app_currency_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название бонуса:", placeholder: "Введите название" }, value: this.state.wager_title, onValueChanged: function (newVal) {
                    _this.setState({
                        wager_title: newVal,
                        wager_title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.wager_title_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: {
                    caption: "Превью бонуса:",
                    placeholder: "Выберите изображение превью",
                    buttonHint: "Выберите изображение превью"
                }, readonly: true, onButtonClick: this.DoShowSelectWagerImageDialog.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        wager_pre_create_teaser_url: newVal,
                        wager_pre_create_teaser_url_rules: { isError: false }
                    });
                }, value: this.state.wager_pre_create_teaser_url, buttonIcon: "search", required: true, rules: this.state.wager_pre_create_teaser_url_rules }),
            this.getActionButtons()));
    };
    BonusTPLLocaleMainEditor.prototype.render = function () {
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 450, customHeight: 'calc( 100vh - 300px )' }, this.getMainEditContent()));
    };
    return BonusTPLLocaleMainEditor;
}(React.Component));
exports.default = BonusTPLLocaleMainEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ui/component/locales/LocaleTPLMainEditor.tsx
// module id = 1906
// module chunks = 0